<ng-template #newSessionTemplate>
	<ui-selection-cards [design]="'default'" [items]="sessionSelectionItems()"></ui-selection-cards>
</ng-template>

<ng-template #selectWorkoutTemplate>
	<lib-list
		[design]="'selectionList'"
		[isInDialog]="true"
		[showNameBasedAvatar]="true"
		[items]="workoutItems()"
	></lib-list>
</ng-template>

<ng-template #editSessionTemplate>
	@if (sharedData(); as sharedData) { @if (selectedSessionItem(); as selectedSessionItem) {

	<mod-edit-session
		[isInDialog]="true"
		(edit)="handleSessionEdit($event)"
		(silentUpdate)="handleSilentUpdate($event)"
		[userItem]="sharedData.data"
		[sessionItem]="selectedSessionItem"
	></mod-edit-session>

	} }
</ng-template>

@if (table(); as table) {
<lib-card>
	<lib-table #tableComponent [table]="table"></lib-table>
</lib-card>
}
